import { render, staticRenderFns } from "./FormElementHeading.vue?vue&type=template&id=63a05704"
import script from "./FormElementHeading.vue?vue&type=script&lang=js"
export * from "./FormElementHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports